import { render, staticRenderFns } from "./RealEstateHistoryView.vue?vue&type=template&id=719ac889&scoped=true&"
import script from "./RealEstateHistoryView.vue?vue&type=script&lang=js&"
export * from "./RealEstateHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateHistoryView.vue?vue&type=style&index=0&id=719ac889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ac889",
  null
  
)

export default component.exports